import React, { Fragment, useEffect, useState } from "react";
import useStyles from "./VendorPopUp.css";
import translation from "../../../i18n/i18.json";

import {
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  ListItemText,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
} from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { useDispatch } from "react-redux";
import AllActions from "../../../actions";
import { FormFieldMeta } from "../../../models/FormValidation/FormFieldMeta";
import { FormError } from "../../../models/FormValidation/FormError";
import {
  InforDisplyaDuration,
  ResponseObjectType,
  VendorForm1Modes,
  FieldsLengthConstants,
  VendorCategoryData,
  SpendManagedByData,
  NavigationPaths,
  RequestTypes
} from "../../../constants/AppConstants";
import {
  AmendRequestData,
  ExtendRequestData,
  VendorRequestChangeData,
} from "../../../models/VendorRequestChange/VendorRequestChangeData";
import {
  VendorExcemptionChangeData
} from "../../../models/VendorExcemptionChangeData";
import { VendorBlockExcemptionService } from "../../../services/VendorBlockExcemptionService";
import { FormUtil } from "../../../utils/FormUtil";
import { FormValidateData } from "../../../models/FormValidation/FormValidateData";
import CancelIcon from "@material-ui/icons/Cancel";
import { Util } from "../../../utils/Util";
import { VendorMasterData } from "../../../services/VendorMasterData";
import { User } from "../../../models/Master/User";
import { CommonRef } from "../../../models/CommonRef";
import { MasterMetaDataService } from "../../../services/MasterMetaDataService";
import { OnBoardingReason } from "../../../models/OnboardingReason";
import ValidationErrors from "../../ErrorList/ValidationErrors";
import { ApprovalPointUtil } from "../../../utils/ApprovalPointUtil";
import { Approver1n2Data } from "../../../models/Approval/Approver1n2Data";
import { RMCategory } from "../../../models/RMCategory";
import { ProcurementCategorySummary, ProcurementSubcategorySummary } from "../../../models/Master/ProcurementCategorySummary";
import { MasterDataService } from "../../../services/MasterDataService";
import { MasterDataUtil } from "../../../utils/masterData/MasterDataUtil";

interface BlockExcemptionDialogProps {
  open: boolean;
  requestMode: VendorForm1Modes;
  title: string;
  id: number;
  vendorNo: string;
  vendorCode: string;
  vendorName: string;
  companyCode: string;
  poCodeList: string;
  bulkOrSample: string;
  vendorCategory: string;
  rmsubCategory: string;
  financeCategory: string;
  reasonForOnboarding: string;
  handleClose: any;
  onUpdateConfirm: any;

}


export default function BlockExcemptionDialog(props: BlockExcemptionDialogProps) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    open,
    requestMode,
    title,
    id,
    vendorNo,
    vendorCode,
    vendorName,
    companyCode,
    poCodeList,
    bulkOrSample,
    vendorCategory,
    rmsubCategory,
    financeCategory,
    reasonForOnboarding,
    handleClose,
    onUpdateConfirm
  } = props;
  const [approver1List, setApprover1List] = useState(Array<User>());
  const [approver2List, setApprover2List] = useState(Array<User>());
  const [approver1Lable, setApprover1Lable] = useState("");
  const [approver2Lable, setApprover2Lable] = useState("");
  const [spendManagedById, setSpendManagedById] = useState(Number);
  const [spendManagedBys, setSpendManagedBys] = useState(Array<CommonRef>());


  const init: VendorExcemptionChangeData = {
    id: 0,
    vendorId: 0,
    vendorNo: "",
    vendorCode: "",
    vendorName: "",
    coCode: "",
    poCode: [],
    isBulk: false,
    onBoardReasonIds: [],
    onBoardReasonDescription: "",
    onBoardingReasons: "",
    rmCategoryIds: [],
    procurementCategoryIds: [],
    procurementSubcategoryIds: [],
    vendorCategoryId: 0,
    extensionReason: "",
    extensionPeriod: 0,
    firstApprovers: [],
    secondApprovers: [],
    spendManagedById: 0
  };

  const [vendorExcemptionChange, setVendorExcemptionChange] = useState<VendorExcemptionChangeData>(init);
  const [formErrors, setFormErrors] = useState<FormError[]>([]);
  const [fistSubmitDone, setFistSubmitDone] = useState(false);
  const [vendorOnboardingReasons, setVendorOnboardingReasons] = useState(Array<OnBoardingReason>());
  const [rmCategories, setRMCategories] = useState(Array<RMCategory>());
  const [procurementSubCategorySummaries, setProcurementSubCategorySummaries] = useState(Array<ProcurementSubcategorySummary>());
  const [procurementSubCategories, setProcurementSubCategories] = useState(Array<ProcurementSubcategorySummary>());
  const [procurementCategories, setProcurementCategories] = useState(Array<ProcurementCategorySummary>());
  const [isProcurementEditable, setIsProcurementEditable] = useState(false);
  const [isRmCategoryEditable, setIsRmCategoryEditable] = useState(false);

  const prepareForRequest = () => {
    dispatch(AllActions.backDropActions.openBackDrop());
  };

  const compeleteRequest = (
    success: boolean,
    message?: string,
    duration?: number
  ) => {
    dispatch(AllActions.backDropActions.closeBackDrop());
    if (message) {
      let messageduration = duration ? duration : InforDisplyaDuration.common;
      if (success) {
        dispatch(
          AllActions.infoActions.openInforSuccess(message, messageduration!)
        );
      } else {
        dispatch(
          AllActions.infoActions.openInforError(message, messageduration!)
        );
      }
    }
  };

  const clearApproverData = () => {
    setApprover1List([]);
    setApprover2List([]);
    setApprover1Lable("");
    setApprover2Lable("");
  }

  const getApproverData = (companyCode: string, vendorCategoryId: number, onBoardReasonIds: number[], isBulk: boolean, spendManagedById: number) => {
    prepareForRequest();
    ApprovalPointUtil.getApproverData(companyCode, vendorCategoryId, onBoardReasonIds, isBulk
      , spendManagedById, RequestTypes.VendorBlockExcemption
      , (approver1n2Data: Approver1n2Data) => {
        setApprover1List(approver1n2Data.approver1List);
        setApprover2List(approver1n2Data.approver2List);
        setApprover1Lable(approver1n2Data.approver1Lable);
        setApprover2Lable(approver1n2Data.approver2Lable);
        compeleteRequest(true);
      }
    );
  }


  const getVendorDataForBlockExcemption = () => {
    prepareForRequest();
    Promise.allSettled([
      VendorBlockExcemptionService.getVendorData(
        vendorNo,
        financeCategory,
        function (data: VendorExcemptionChangeData) {
          if (data) {
            data.coCode = companyCode.split(',')[0];
            data.poCode = poCodeList.split(',');
            data.vendorName = vendorName;
            data.id = id;
            if (data.vendorCategoryId == VendorCategoryData.RM) {
              data.extensionPeriod = 6;
            }
            else {
              data.extensionPeriod = 18;
            }

            setIsRmCategoryEditable(!data.rmCategoryIds || data.rmCategoryIds.length == 0);
            setIsProcurementEditable(!data.procurementSubcategoryIds || data.procurementSubcategoryIds.length == 0);
            setVendorExcemptionChange(data);

            getApproverData(companyCode.split(',')[0], data.vendorCategoryId, data.onBoardReasonIds
              , data.isBulk, data.spendManagedById);
            getPromiseOnboardingReasons(data.vendorCategoryId);
            getSpendManagedByData(data.vendorCategoryId);
            setSpendManagedById(vendorExcemptionChange.spendManagedById);
          }
        },
        function (error: Error) {
          console.log(error);
          setVendorExcemptionChange(init);
        }
      ),

      function (error: Error) {
        console.log(error);
      }
    ]).then((values) => {
      // compeleteRequest(true);
    });
  };

  const loadProcurementCatList = (procurementCatList: ProcurementSubcategorySummary[]) => {
    let procurementCats: ProcurementCategorySummary[] = [];
    procurementCatList.forEach(p => {
      if (!procurementCats.find(e => e.procurmentCategoryId == p.procurmentCategoryId)) {
        procurementCats.push({
          vendorCategoryId: p.vendorCategoryId,
          procurmentCategoryId: p.procurmentCategoryId,
          procurmentCategoryName: p.procurmentCategoryName
        });
      }
    });
    setProcurementCategories(Util.sortObjByString(procurementCats, "procurmentCategoryName") as ProcurementCategorySummary[]);
  };

  const getPromiseRMCategoryData = (vendorCategoryId: number) => {
    return MasterMetaDataService.getRMCategories(
      function (userRmCategoryList: Array<RMCategory>) {
        setRMCategories(userRmCategoryList);
      },
      function () {
        setRMCategories([]);
      }
    );
  };

  const getPromiseProcurmentSubcategoryData = (vendorCategoryId: number) => {
    return MasterDataService.getProcurementSubcategorySummaries(
      RequestTypes.VendorExtend,
      vendorCategoryId,
      function (procurementCatList: Array<ProcurementSubcategorySummary>) {
        setProcurementSubCategorySummaries(Util.sortObjByString(procurementCatList, "procurmentCategoryName") as ProcurementSubcategorySummary[]);
        loadProcurementCatList(procurementCatList);
      },
      function () {
        setProcurementSubCategorySummaries([]);
      }
    );
  };

  const loadMasterData = () => {
    if (vendorExcemptionChange.vendorCategoryId == VendorCategoryData.RM) {
      getPromiseRMCategoryData(vendorExcemptionChange.vendorCategoryId);
    } else if (vendorExcemptionChange.vendorCategoryId == VendorCategoryData.NonRM
      || vendorExcemptionChange.vendorCategoryId == VendorCategoryData.Services) {
      getPromiseProcurmentSubcategoryData(vendorExcemptionChange.vendorCategoryId);
    }
  };

  useEffect(() => {
    if (vendorExcemptionChange.procurementCategoryIds && vendorExcemptionChange.procurementCategoryIds.length > 0) {
      //vendorExtendRequest.procurementSubcategoryIds = [];
      let procurementSubcats: ProcurementSubcategorySummary[] = [];
      procurementSubCategorySummaries.forEach(p => {
        if (vendorExcemptionChange.procurementCategoryIds.find((e: number) => e == p.procurmentCategoryId)) {
          procurementSubcats.push(p);
        }
      });
      setProcurementSubCategories(procurementSubcats);
    } else {
      vendorExcemptionChange.procurementSubcategoryIds = [];
      setProcurementSubCategories([]);
    }
  }, [vendorExcemptionChange.procurementCategoryIds, procurementSubCategorySummaries]);

  useEffect(() => {
    if (vendorNo) {
      getVendorDataForBlockExcemption();
    }
  }, [vendorNo]);

  useEffect(() => {
    if (vendorExcemptionChange.vendorCategoryId > 0) {
      loadMasterData();
    }
  }, [vendorExcemptionChange.vendorCategoryId]);

  useEffect(() => {
    if (vendorExcemptionChange.coCode && vendorExcemptionChange.vendorCategoryId > 0) {
      //if (!isInitialVendorDetailData) {
      //showLoadingMask();
      getApproverData(vendorExcemptionChange.coCode, vendorExcemptionChange.vendorCategoryId, vendorExcemptionChange.onBoardReasonIds
        , vendorExcemptionChange.isBulk, vendorExcemptionChange.spendManagedById || 0);
      //}
    } else {
      clearApproverData();
    }
  }, [vendorExcemptionChange.spendManagedById]);

  useEffect(() => {
    if (fistSubmitDone) {
      validateData(false);
    }
  }, [vendorExcemptionChange]);

  const getSpendManagedByData = (vendorCategoryId: number) => {
    return (vendorCategoryId == VendorCategoryData.NonRM
      || vendorCategoryId == VendorCategoryData.Services)
      ? VendorMasterData.getSpendManagedBy(
        function (list: Array<CommonRef>) {
          if (vendorCategoryId == VendorCategoryData.NonRM) {
            list = list.filter(v => v.id == SpendManagedByData.GroupProcurement
              || v.id == SpendManagedByData.ProcureM || v.id == SpendManagedByData.GroupProcurementAndProcureM);
          } else if (vendorCategoryId == VendorCategoryData.Services) {
            list = list.filter(v => v.id == SpendManagedByData.GroupProcurement
              || v.id == SpendManagedByData.SBU || v.id == SpendManagedByData.GroupProcurementAndSBU);
          }
          setSpendManagedBys(Util.sortObjByString(list, "name") as CommonRef[]);
        },
        function (error: Error) {
          setSpendManagedBys([]);
        }
      )
      : Promise.resolve([]);
  };


  const isRmOrNonRmOrServices = () => {
    return vendorExcemptionChange.vendorCategoryId == VendorCategoryData.NonRM
      || vendorExcemptionChange.vendorCategoryId == VendorCategoryData.Services
      || vendorExcemptionChange.vendorCategoryId == VendorCategoryData.RM;
  };

  const isNonRmOrServices = () => {
    return vendorExcemptionChange.vendorCategoryId == VendorCategoryData.NonRM
      || vendorExcemptionChange.vendorCategoryId == VendorCategoryData.Services;
  };
  const isServicesBySbu = () => {
      return vendorExcemptionChange.vendorCategoryId == VendorCategoryData.Services
        && (vendorExcemptionChange.spendManagedById == SpendManagedByData.SBU
          || vendorExcemptionChange.spendManagedById == SpendManagedByData.GroupProcurementAndSBU);
    };

  const handleEnter = (e: any) => {
    prepareForRequest();
    setSpendManagedById(vendorExcemptionChange.spendManagedById);

  };

  const handleExit = (e: any) => {
    setVendorExcemptionChange(init);
    setFormErrors([]);
    setFistSubmitDone(false);
  };


  const submitBlockExcemptionRequest = () => {
    prepareForRequest();
    // if (vendorExcemptionChange.spendManagedById == SpendManagedByData.SBU) {

    // }
    // else {
    //   vendorExcemptionChange.firstApprovers = approver1List.map(g => g.emailAddress);
    // }
    // vendorExcemptionChange.firstApprovers = firstAp.map(g => g.emailAddress);
    // vendorExcemptionChange.secondApprovers = approver2List.map(g => g.emailAddress);

    VendorBlockExcemptionService.submitVendorExcemptionRequest(
      vendorExcemptionChange,
      function (vendorExcemptionData: any) {
        if (
          vendorExcemptionData &&
          vendorExcemptionData.resposeObjectType === ResponseObjectType.Error
        ) {
          compeleteRequest(false, vendorExcemptionData.message);
        } else {
          onUpdateConfirm();
          compeleteRequest(
            true,
            `${vendorExcemptionData.result} ${translation.vendorchangepopup_block_excemption_sucess}`,
            InforDisplyaDuration.approvalStatus,
          );
          //history.push(NavigationPaths.Dashboard);

          handleClose(true);
        }
      },
      function (error: Error) {
        console.log(error);
        compeleteRequest(false, translation.vendorchangepopup_extend_error_err);
      }
    );
  };

  const handleConfirm = (e: any) => {
    setFistSubmitDone(true);
    if (validateData(true)) {
      submitBlockExcemptionRequest();
    }
  };

  const getPromiseOnboardingReasons = (vendorCategoryId: number) => {
    MasterMetaDataService.getOnBoardingReasons(
      vendorCategoryId,
      function (onboardingReasonList: Array<OnBoardingReason>) {
        setVendorOnboardingReasons(onboardingReasonList);
        compeleteRequest(true);
      },
      function (error: Error) {
        setVendorOnboardingReasons([]);
        compeleteRequest(true);
      }
    );
  };



  const handleChange = (input: string) => (e: any) => {

    if (input === "extensionReason") {
      if (e.target.value == "") {
        setVendorExcemptionChange({ ...vendorExcemptionChange!, [input]: "", });
      } else {
        setVendorExcemptionChange({ ...vendorExcemptionChange!, [input]: e.target.value, });
      }
    } else if (input === "isBulk") {
      setVendorExcemptionChange({ ...vendorExcemptionChange!, [input]: e.target.value == "true" ? true : false });
      // getApproverData(companyCode.split(',')[0], vendorExcemptionChange.vendorCategoryId, vendorExcemptionChange.onBoardReasonIds
      //   , e.target.value == "true" ? true : false, vendorExcemptionChange.spendManagedById);
    }
    else if (input === "spendManagedById") {
      setVendorExcemptionChange({ ...vendorExcemptionChange!, [input]: e.target.value, });
      // getApproverData(companyCode.split(',')[0], vendorExcemptionChange.vendorCategoryId, vendorExcemptionChange.onBoardReasonIds
      //   , vendorExcemptionChange.isBulk, e.target.value);
    }
    else if (input === "onBoardReasonIds") {
      let newValue = e.target.value
        ? e.target.value.find((v: number) => !vendorExcemptionChange?.onBoardReasonIds.includes(v))
        : null;
      if (!(newValue && vendorExcemptionChange?.onBoardReasonIds.length > 0) //delete or first value
        || ApprovalPointUtil.isOnboardingReasonAllowed(vendorExcemptionChange.onBoardReasonIds, newValue)) {
        setVendorExcemptionChange({ ...vendorExcemptionChange!, [input]: e.target.value, });
        // getApproverData(companyCode.split(',')[0], vendorExcemptionChange.vendorCategoryId, e.target.value
        //   , vendorExcemptionChange.isBulk, vendorExcemptionChange.spendManagedById);
      }
      else {
        //not allowed
        dispatch(AllActions.infoActions.openInforError(translation.vendor_crete_form1_onboarding_reason_not_allowed_msg, InforDisplyaDuration.common));
      }
    } else if (input === "rmCategoryIds") {
      setVendorExcemptionChange({ ...vendorExcemptionChange!, [input]: e.target.value ? [e.target.value] : [] });
    } else if (input === "procurementCategoryIds") {
      setProcurementSubCategories([]);
      setVendorExcemptionChange({
        ...vendorExcemptionChange
        , "procurementSubcategoryIds": []
        , [input]: e.target.value ? [e.target.value] : []
      });
    } else if (input === "procurementSubcategoryIds") {
      let procSubCatId = e.target.value;
      let spendManagedById = 0;
      if (procSubCatId > 0) {
        let procCat = procurementSubCategorySummaries.find(p => p.procurmentSubcategoryId == procSubCatId);
        spendManagedById = procCat ? procCat.spendManagedById : 0;
      }
      setVendorExcemptionChange({ ...vendorExcemptionChange!, [input]: procSubCatId ? [procSubCatId] : [], spendManagedById: spendManagedById });
    } else if (input === "firstApprovers") {
      setVendorExcemptionChange({ ...vendorExcemptionChange!, [input]: e.target.value, });
    }
    else {
      setVendorExcemptionChange({ ...vendorExcemptionChange!, [input]: e.target.value, });
    }
  };

  const handleDelete = (e: React.MouseEvent, value: any, input: string) => {
    e.preventDefault();

    if (input === "firstApprovers") {
      setVendorExcemptionChange({
        ...vendorExcemptionChange!,
        "firstApprovers": vendorExcemptionChange.firstApprovers.filter((email: string) => { return email !== value; })
      });
    }
    else if (input === "secondApprovers") {
      setVendorExcemptionChange({
        ...vendorExcemptionChange!,
        "secondApprovers": vendorExcemptionChange.secondApprovers.filter((email: string) => { return email !== value; })
      });
    }
    else if (input === "onBoardReasonIds") {
      setVendorExcemptionChange({
        ...vendorExcemptionChange!,
        "onBoardReasonIds": vendorExcemptionChange.onBoardReasonIds.filter((id: number) => { return id !== value; })
      });
    }
  };

  const getErrorState = (input: string) => {
    // console.log("getErrorState");
    var errIndex = formErrors.findIndex(function (row) {
      return row.fieldName === input && row.errorMsg;
    });
    return errIndex !== -1 ? true : false;
  };

  const isOnboardingReasonActive = (reasonId: number) => {
    return (!vendorExcemptionChange.OnBoardReasonIds || vendorExcemptionChange.OnBoardReasonIds.length == 0
      || ApprovalPointUtil.isOnboardingReasonAllowed(vendorExcemptionChange.OnBoardReasonIds, reasonId))
      ? true : false;
  }



  const validateData = (isSubmit: boolean) => {
    //setFormErrors([]);
    setFormErrors([]);
    let validateFieldsData: Array<FormFieldMeta> = [
    ];
    validateFieldsData = [
      {
        fieldName: "firstApprovers",
        isRequired: !isRmOrNonRmOrServices() || isServicesBySbu(),
        reuiredMsg: approver1Lable + " required",
        isList: true,
      },
      {
        fieldName: "secondApprovers",
        isRequired: !isRmOrNonRmOrServices(),
        reuiredMsg: approver2Lable + " required",
        isList: true,
      },
      {
        fieldName: "extensionReason",
        isRequired: true,
        reuiredMsg: "Extension Reason is required",
      },
      {
        fieldName: "rmCategoryIds",
        isRequired: vendorExcemptionChange.vendorCategoryId == VendorCategoryData.RM ? true : false,
        reuiredMsg: "RM Category is required",
        isList: true
      },
      {
        fieldName: "procurementCategoryIds",
        isRequired: isNonRmOrServices(),
        reuiredMsg: "Procurement Category is required",
        isList: true
      },
      {
        fieldName: "procurementSubcategoryIds",
        isRequired: isNonRmOrServices(),
        reuiredMsg: "Procurement Subcategory is required",
        isList: true
      },
      // {
      //   fieldName: "onBoardReasonIds",
      //   isRequired: isRmOrNonRmOrServices(),
      //   reuiredMsg: "Onboarding Reason is required",
      //   isList: true
      // }
    ];

    let formValidateData: FormValidateData = FormUtil.validateFields(
      validateFieldsData,
      vendorExcemptionChange
    );

    setFormErrors(formValidateData.errorsList);
    return formValidateData.isValid;
  };

  return (
    <div className={classes.popUpOuter}>
      <Dialog
        open={open}
        onClose={handleClose}
        onExit={handleExit}
        onEnter={handleEnter}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="xl"
      >
        <DialogTitle className={classes.popUpHeader} id="alert-dialog-title">
          {(title) + " - " + "[ Vendor No : " + (vendorNo) + " , " + "Vendor Name : " + (vendorName) + " ]"}
          {/* {translation.vendorchangepopup_unblock_title} */}
        </DialogTitle>
        <DialogContent>
          {/* <DialogContentText id="alert-dialog-description"> */}
          <div>
            <div>
              <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12}>
                <Grid item xs={12} sm={12} md={6} lg={4} style={{ margin: "0 0px 10px", float: "left", }}>
                  <span className={classes.createLbl}>
                    {translation.vendorchangepopup_extensionreason_lbl}
                  </span>
                  {<div className={classes.inputWrapper_Req}>
                    <TextField
                      variant="outlined"
                      value={vendorExcemptionChange?.extensionReason || ""}
                      onChange={handleChange("extensionReason")}
                      error={getErrorState("extensionReason")}
                      inputProps={{
                        maxLength: FieldsLengthConstants.RequestComments,
                      }}
                    />
                  </div>}
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={4} style={{ margin: "0 0px 10px", float: "left", }}>
                  <span className={classes.createLbl}>
                    {translation.vendorchangepopup_extensionperiod_lbl}
                  </span>
                  <div className={classes.inputWrapper}>
                    <TextField
                      variant="outlined"
                      //value={vendorExcemptionChange.extensionPeriod || ""}
                      value={vendorExcemptionChange.vendorCategoryId == VendorCategoryData.RM ? "6 Months" : "18 Months"}
                      onChange={handleChange("extensionPeriod")}
                      error={getErrorState("extensionPeriod")}
                      disabled={true}

                    />
                  </div>
                </Grid>
                {/* {(vendorExcemptionChange.vendorCategoryId == VendorCategoryData.RM) && (
                  <Grid item container xs={12} sm={12} md={6} lg={4} >
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <span className={classes.createLbl}>
                        {translation.vendor_crete_form1_BulkSample_lbl}
                      </span>
                    </Grid>
                    <Grid className={classes.inputWrapper_Req} item xs={12} sm={12} md={12} lg={12} style={{ width: "50%", float: "left" }}>
                      <div className={classes.switchDiv}>
                        <FormControl component="fieldset">
                          <FormLabel component="legend"></FormLabel>
                          <RadioGroup row aria-label="Bulk/Sample" name="IsBulk" value={vendorExcemptionChange.isBulk} onChange={handleChange("isBulk")}>
                            <FormControlLabel disabled={((vendorExcemptionChange.vendorId != 0)) ? true : false} value={true} checked={vendorExcemptionChange.isBulk === true} control={<Radio />} label="Bulk" />
                            <FormControlLabel disabled={((vendorExcemptionChange.vendorId != 0)) ? true : false} value={false} checked={vendorExcemptionChange.isBulk === false} control={<Radio />} label="Sample" />
                          </RadioGroup>
                        </FormControl>
                      </div>
                    </Grid>
                  </Grid>
                )} */}


                {/*  {(vendorExcemptionChange.vendorId == 0 || (vendorExcemptionChange.onBoardReasonIds.length == 0)) ? ( */}
                {/* {(vendorExcemptionChange.vendorId == 0 || (vendorExcemptionChange.onBoardingReasons!="")) ? (
                  <Grid item xs={12} sm={12} md={6} lg={4}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <span className={classes.createLbl}>
                        {translation.vendor_crete_form1_OnBoard_Reason_lbl}
                      </span>
                    </Grid>
                    <Grid className={classes.inputWrapper_Req}>
                      <Select
                        variant="outlined"
                        multiple
                        value={vendorExcemptionChange.onBoardReasonIds || []}
                        onChange={handleChange("onBoardReasonIds")}
                        error={getErrorState("onBoardReasonIds")}
                        renderValue={(selected) => (
                          <div>
                            {(selected as number[]).map((value) => (
                              <Chip
                                key={value}
                                label={vendorOnboardingReasons.find(r => r.id == value)?.vendorOnboardingReasonName}
                                clickable
                                deleteIcon={
                                  <CancelIcon
                                    onMouseDown={(event) => event.stopPropagation()}
                                  />
                                }
                                onDelete={(e) => handleDelete(e, value, "onBoardReasonIds")}
                              />
                            ))}
                          </div>
                        )}
                      >
                        {vendorOnboardingReasons.map((obj, index) => (
                          <MenuItem key={obj.id} value={obj.id}>
                            <Checkbox
                              //disabled = {!isOnboardingReasonActive(obj.id)}
                              checked={vendorExcemptionChange.onBoardReasonIds.includes(obj.id)}
                            />
                            <ListItemText primary={obj.vendorOnboardingReasonName} />
                          </MenuItem>
                        ))}
                      </Select>
                    </Grid>
                  </Grid>
                ) : (

                  <Grid item xs={12} sm={12} md={6} lg={4}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <span className={classes.createLbl}>
                        {translation.vendor_crete_form1_OnBoard_Reason_lbl}
                      </span>
                    </Grid>
                    <Grid>
                      <div className={classes.inputWrapper}>
                        <TextField
                          variant="outlined"
                          value={vendorExcemptionChange.onBoardingReasons}
                          onChange={handleChange("onBoardReasonIds")}
                          error={getErrorState("onBoardReasonIds")}
                          disabled={true}

                        />
                      </div>
                    </Grid>
                  </Grid>
                )}
                {(vendorExcemptionChange.vendorCategoryId === VendorCategoryData.NonRM
                  || vendorExcemptionChange.vendorCategoryId === VendorCategoryData.Services) && (
                    <Grid item xs={12} sm={12} md={6} lg={4}>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <span className={classes.createLbl}>
                          {translation.vendor_crete_form1_spend_managed_by_lbl}
                        </span>
                      </Grid>
                      <Grid className={classes.inputWrapper_Req}>
                        <Select
                          disabled={(vendorExcemptionChange.vendorId != 0 && vendorExcemptionChange.vendorId != null && vendorExcemptionChange.spendManagedById != 0) ? true : false}
                          variant="outlined"
                          value={vendorExcemptionChange.spendManagedById || ""}
                          onChange={handleChange("spendManagedById")}
                          error={getErrorState("spendManagedById")}
                        >
                          {spendManagedBys.map((obj, index) => (
                            <MenuItem key={obj.name} value={obj.id}>
                              {obj.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </Grid>
                    </Grid>
                  )} */}


                {vendorExcemptionChange.vendorCategoryId == VendorCategoryData.RM && (
                  <Fragment>
                    <Grid item container xs={12} sm={12} md={6} lg={4} >
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <span className={classes.createLbl}>
                          {translation.vendor_crete_form1_BulkSample_lbl}
                        </span>
                      </Grid>
                      <Grid className={classes.inputWrapper_Req} item xs={12} sm={12} md={12} lg={12} style={{ width: "50%", float: "left" }}>
                        <span>{vendorExcemptionChange.isBulk ? "Bulk" : "Sample"}</span>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={4}>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <span className={classes.createLbl}>
                          {translation.vendor_crete_form1_RMCategory_lbl}
                        </span>
                      </Grid>
                      <Grid className={classes.inputWrapper_Req}>
                        <Select
                          variant="outlined"
                          value={vendorExcemptionChange.rmCategoryIds[0] || 0}
                          onChange={handleChange("rmCategoryIds")}
                          inputProps={{ readOnly: !isRmCategoryEditable }}
                          error={getErrorState("rmCategoryIds")}
                        >
                          <MenuItem value="">
                            <em>{translation.dropdown_empty_text}</em>
                          </MenuItem>
                          {rmCategories.map((obj) => (
                            <MenuItem key={obj.id} value={obj.id}>
                              {obj.rmCategoryName}
                            </MenuItem>
                          ))}
                        </Select>
                      </Grid>
                    </Grid>
                  </Fragment>)
                }
                {(vendorExcemptionChange.vendorCategoryId == VendorCategoryData.NonRM
                  || vendorExcemptionChange.vendorCategoryId == VendorCategoryData.Services
                ) && (
                    <Fragment>
                      <Grid item xs={12} sm={12} md={6} lg={4}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                          <span className={classes.createLbl}>
                            {translation.vendor_crete_form1_procurement_cat_lbl}
                          </span>
                        </Grid>
                        <Grid className={classes.inputWrapper_Req}>
                          <Select
                            variant="outlined"
                            value={vendorExcemptionChange.procurementCategoryIds[0] || 0}
                            onChange={handleChange("procurementCategoryIds")}
                            inputProps={{ readOnly: !isProcurementEditable }}
                            error={getErrorState("procurementCategoryIds")}
                          >
                            <MenuItem value="">
                              <em>{translation.dropdown_empty_text}</em>
                            </MenuItem>
                            {procurementCategories.map((obj) => (
                              <MenuItem key={obj.procurmentCategoryId} value={obj.procurmentCategoryId}>
                                {obj.procurmentCategoryName}
                              </MenuItem>
                            ))}
                          </Select>
                        </Grid>
                      </Grid>
                      <Grid item xs={12} sm={12} md={6} lg={4}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                          <span className={classes.createLbl}>
                            {translation.vendor_crete_form1_procurement_subcat_lbl}
                          </span>
                        </Grid>
                        <Grid className={classes.inputWrapper_Req}>
                          <Select
                            variant="outlined"
                            value={vendorExcemptionChange.procurementSubcategoryIds[0] || 0}
                            onChange={handleChange("procurementSubcategoryIds")}
                            inputProps={{ readOnly: !isProcurementEditable }}
                            error={getErrorState("procurementSubcategoryIds")}
                          >
                            <MenuItem value="">
                              <em>{translation.dropdown_empty_text}</em>
                            </MenuItem>
                            {procurementSubCategories.map((obj) => (
                              <MenuItem key={obj.procurmentSubcategoryId} value={obj.procurmentSubcategoryId}>
                                {MasterDataUtil.getNameFromProcSubCategorName(obj.procurmentSubcategoryName)}
                              </MenuItem>
                            ))}
                          </Select>
                          <span className={classes.helpLbl}>{
                            MasterDataUtil.getSpendMngByFromProcSubCategorId(procurementSubCategories
                            ,vendorExcemptionChange.procurementSubcategoryIds[0] || 0)}
                          </span>
                        </Grid>
                      </Grid>
                    </Fragment>)
                }
                {approver1List && approver1List.length > 0 && (
                  <Fragment>
                    <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12} >
                      <span className={classes.popUpHeaderTxt}>
                        {translation.vendor_crete_form1_approvers_section_title}
                      </span>
                      <span className={classes.popUpHeaderLine}></span>
                    </Grid>
                    <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12}>
                      <Grid item xs={12} sm={12} md={6} lg={4}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                          <span className={classes.createLbl}>{approver1Lable}</span>
                        </Grid>
                        <Grid className={classes.inputWrapper_Req}>
                          {(!isRmOrNonRmOrServices() || isServicesBySbu()) && (<Select
                            //disabled={!isEditableMode()}
                            variant="outlined"
                            multiple
                            value={vendorExcemptionChange.firstApprovers || []}
                            onChange={handleChange("firstApprovers")}
                            error={getErrorState("firstApprovers")}
                            renderValue={(selected) => (
                              <div>
                                {(selected as string[]).map((value) => (
                                  <Chip
                                    key={value}
                                    label={value}
                                    clickable
                                    deleteIcon={
                                      <CancelIcon
                                        onMouseDown={(event) => event.stopPropagation()}
                                      />
                                    }
                                    onDelete={(e) => handleDelete(e, value, "firstApprovers")}
                                  />
                                ))}
                              </div>
                            )}
                          >
                            {approver1List.map((obj, index) => (
                              <MenuItem key={obj.emailAddress} value={obj.emailAddress}>
                                <Checkbox
                                  checked={((vendorExcemptionChange.firstApprovers != null) ? vendorExcemptionChange.firstApprovers.includes(obj.emailAddress) : false)}
                                />
                                <ListItemText primary={obj.emailAddress} />
                              </MenuItem>
                            ))}
                          </Select>)}
                          {/* {(isRmOrNonRmOrServices() && !isServicesBySbu()) && (
                            <span className={classes.textWrap}>
                              {`${approver1List.map((obj) => obj.emailAddress + ' ')}`}
                            </span>
                          )} */}
                        </Grid>
                      </Grid>
                      {approver2List.length > 0 && (<Grid item xs={12} sm={12} md={6} lg={4}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                          <span className={classes.createLbl}>{approver2Lable}</span>
                        </Grid>
                        <Grid className={classes.inputWrapper_Req}>
                          {!isRmOrNonRmOrServices() && (<Select
                            //disabled={!isEditableMode()}
                            variant="outlined"
                            multiple
                            value={vendorExcemptionChange.secondApprovers || []}
                            onChange={handleChange("SecondApprovers")}
                            error={getErrorState("SecondApprovers")}
                            renderValue={(selected) => (
                              <div>
                                {(selected as string[]).map((value) => (
                                  <Chip
                                    key={value}
                                    label={value}
                                    clickable
                                    deleteIcon={
                                      <CancelIcon
                                        onMouseDown={(event) => event.stopPropagation()}
                                      />
                                    }
                                    onDelete={(e) => handleDelete(e, value, "SecondApprovers")}
                                  />
                                ))}
                              </div>
                            )}
                          >
                            {approver2List.map((obj, index) => (
                              <MenuItem key={obj.emailAddress} value={obj.emailAddress}>
                                <Checkbox
                                  checked={vendorExcemptionChange.secondApprovers.includes(obj.emailAddress)}
                                />
                                <ListItemText primary={obj.emailAddress} />
                              </MenuItem>
                            ))}
                          </Select>)}
                          {/* {isRmOrNonRmOrServices() && (
                            <span className={classes.textWrap}>
                              {`${approver2List.map((obj) => obj.emailAddress + ' ')}`}
                            </span>
                          )} */}
                        </Grid>
                      </Grid>)}
                    </Grid>
                  </Fragment>)}
              </Grid>
            </div>
          </div>
          {/* </DialogContentText> */}
        </DialogContent>
        <div style={{ margin: "25px 0 0 0" }}>
          <DialogActions>
            <div style={{ margin: "20px ​10px 15px 0" }}>
              <div className={classes.greenBtnWrapper}>
                <Button onClick={handleConfirm} color="primary">
                  <CheckCircleIcon></CheckCircleIcon>
                  {translation.vendor_crete_form1_submit_btn}
                </Button>
              </div>
              {/* )} */}

              <div className={classes.grayBtnWrapper}>
                <Button onClick={handleClose} color="primary" autoFocus>
                  {translation.vendorchangepopup_close_btn}
                </Button>
              </div>
            </div>
          </DialogActions>
        </div>
      </Dialog>

    </div>
  );
}
